import React, { useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./DerivedVisualPage.module.css";
import { usePassions } from "../../hooks/usePassions";
import { useAcid } from "../../hooks/useAcid";
import { VisualPage } from "../Visual/VisualPage";
import { Heading, BtnUi, Icon, PreferencesNoticeUi } from "~/components";
import { sendAnalyticsPageViewEvent } from "../../utils/adobeDataLayerUtils";

export const DerivedVisualPage = () => {
  const experienceType = "derived-visual";
  const { tapPassion, unselectPassion, savePassionsToServer } =
    usePassions(experienceType);
  const [showVisualPage, setShowVisualPage] = useState(false);
  const { acid } = useAcid();

  const handlePassionClick = async (passion) => {
    if (passion) {
      tapPassion("golf", 2, passion);
    } else {
      unselectPassion("golf");
    }
    await savePassionsToServer(acid);
    setShowVisualPage(true);
  };

  useEffect(() => {
    sendAnalyticsPageViewEvent("Passions-Golf", 'Passions-Collection');
  }, []);


  if (showVisualPage) {
    return <VisualPage mode="derived" experienceType={experienceType} />;
  }

  return (
    <>
      <div className={styles.header}>
        <Heading type="h1" text="Do you love golf?" />
        <p className={styles.subheader}>
          Tap to confirm if you’re passionate about golf to tee up a more
          relevant experience.
        </p>
      </div>
      <div className={styles.imgContainer}>
        <img
          src="https://cache.marriott.com/is/image/marriotts7prod/mc-wasbd-golf-course-35141?wid=360&fit=constrain"
          alt="image of a golfer"
          className={styles.img}
        />
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.btnGroup}>
          <BtnUi
            className={classNames(styles.yesBtn, "custom_click_track")}
            data-custom_click_track_value={`Golf|Like Golf|internal`}
            onClick={() => handlePassionClick(1)}
          >
            <Icon name="like" />
            <span className={styles.btnText}>I like to golf</span>
          </BtnUi>
          <BtnUi
            className={classNames(styles.yesBtn, "custom_click_track")}
            data-custom_click_track_value={`Golf|Love Golf|internal`}
            onClick={() => handlePassionClick(2)}
          >
            <Icon name="heart" />
            <span className={styles.btnText}>I love to golf</span>
          </BtnUi>
        </div>
        <BtnUi
          className={classNames(styles.noBtn, "custom_click_track")}
          data-custom_click_track_value={`Golf|No Golf|internal`}
          onClick={() => handlePassionClick(0)}
        >
          <span>No, but I have other interests</span>
          <Icon name="arrowRightNoLine" className={styles.btnOtherIcon} />
        </BtnUi>
        <PreferencesNoticeUi />
      </div>
    </>
  );
};
